// extracted by mini-css-extract-plugin
module.exports = {"container":"OfflineOrderDetailsEditButton_container__3D3It","container-ltr":"OfflineOrderDetailsEditButton_container-ltr__3s-0A"};